import type BABYLON from 'babylonjs';

import type { Globals } from './globals';

export type Color = BABYLON.Color3 | BABYLON.Color4 | ArrayLike<number> | string;

export function toColor3(globals: Globals, color: Color): BABYLON.Color3 {
  if (color instanceof globals.BABYLON.Color3) return color;
  if (color instanceof globals.BABYLON.Color4)
    return new globals.BABYLON.Color3(color.r, color.g, color.b);
  if (typeof color === 'string') return globals.BABYLON.Color3.FromHexString(color);
  return globals.BABYLON.Color3.FromArray(color);
}

export function toColor3Option(
  globals: Globals,
  color: Color | null | undefined
): BABYLON.Color3 | undefined {
  return color != null ? toColor3(globals, color) : undefined;
}

export function toColor4(globals: Globals, color: Color): BABYLON.Color4 {
  if (color instanceof globals.BABYLON.Color4) return color;
  if (color instanceof globals.BABYLON.Color3) return color.toColor4();
  if (typeof color === 'string') return globals.BABYLON.Color4.FromHexString(color);
  return globals.BABYLON.Color4.FromArray(color);
}

export function toColor4Option(
  globals: Globals,
  color: Color | null | undefined
): BABYLON.Color4 | undefined {
  return color != null ? toColor4(globals, color) : undefined;
}
